import React from "react";
import styled from 'styled-components';
import ClaroParagraph from '../../../atoms/ClaroParagraph';
import { CREDIT_CLARO_PAY, servicesIdTAE } from "../../../../constants";

const Container = styled.div`
    width: 96%;
    background: ${props => props.background ? props.background : '#fff'};
    margin: 2%;
    text-align: center;
`;

const TextAmount = styled.p`
    color: ${props => props.color };
    font-size: ${props => props.fontSize ? props.fontSize : "12px"};
    font-weight: ${props => props.weight ? props.weight : "bold"};
    font-family: ${props => props.fontFamily ? props.fontFamily : "Amx-Regular"};
    display: inline;
    margin: 0;
`;

class CommisionModule extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            showDetailComision: false,
            marginTotalCommissions: this.props.isContainerTelcel && !this.props.isClaroPartner 
                ? "1em 0em 0em 0em" 
                : "2em 0em .8em 0em",
            marginDetailCommissions: "0em 0em 0em 0em"
        }
    }

    componentDidMount() {
        const {logicType, isClaroPartner} = this.props
        if(logicType === "sears"){
            this.setState({
                marginTotalCommissions : "2em 0em .6em 0em",
                marginDetailCommissions: "0em 0em .6em 0em"
            })
        }
        if(isClaroPartner){
            this.setState({marginTotalCommissions : "0em 0em 1.8em 0em"})
        }
    }

    handleOnclickDetailComision = () => {
        if(!this.state.showDetailComision){
            this.setState({showDetailComision:true})
        }else{
            this.setState({showDetailComision:false})
        }
    }
      
    render(){
        let {isClaroPartner, commissionData, amount, isContainerTelcel} = this.props
        let amountColor = (isClaroPartner)?"#ff6028":"#9b9b9b";
            amountColor = !isClaroPartner && isContainerTelcel ? "#757575" : amountColor;
        let showLess = (isClaroPartner)?"/images/icono_ver_menos.svg":"/images/flecha_arriba.png";
            showLess = !isClaroPartner && isContainerTelcel ? "/images/icono-ver-menos-contenedor.png" : showLess;
        let showMore = (isClaroPartner)?"/images/icono_ver_mas.svg":"/images/flecha_abajo.png";
            showMore = !isClaroPartner && isContainerTelcel ? "/images/icono-ver-mas-contenedor.png" : showMore;
        let imgWidth = (isClaroPartner)?"25px":"12px";
            imgWidth = !isClaroPartner && isContainerTelcel ? "20px" : imgWidth;
        let imgHeight = (isClaroPartner)?"22px":"10px";
            imgHeight = !isClaroPartner && isContainerTelcel ? "20px" : imgHeight;
        let imgVerticalAlign = (isClaroPartner)?"bottom":"middle";
        let paymentMethodIsCredit = (this.props.cardId == CREDIT_CLARO_PAY)
        let comisionService = 0;
        let comisionCard = 0;
        let comisionTotal = !isClaroPartner && isContainerTelcel ? "00.00" : 0;
        let alignComisions = isClaroPartner || this.props.logicType == "sears" ?"center":"left"
        if(commissionData.length != 0){
            const { commissionByService, totalPayMethod, totalCommission } = commissionData[0];
            comisionCard = paymentMethodIsCredit ? 0 : totalPayMethod
            comisionService = paymentMethodIsCredit ? 0 : commissionByService.toFixed(2)
            comisionTotal = paymentMethodIsCredit ? 0 : totalCommission.toFixed(2)
        }

        let {marginTotalCommissions, marginDetailCommissions} = this.state
        const paymentTypeLineHeight = !isClaroPartner && isContainerTelcel ? "20px" : "normal";

        return(
            <Container background={!isClaroPartner && isContainerTelcel ? "#fff" : undefined}>
                {
                    <>
                        <ClaroParagraph 
                            margin={marginTotalCommissions}
                            normal={true} 
                            align= {alignComisions}
                            center = {true}
                            fontSize={!isClaroPartner && isContainerTelcel ? "12px" : "11px"}
                            fontFamily={!isClaroPartner && isContainerTelcel ? "AMX-Regular" : "roboto"}
                            fontColor={!isClaroPartner && isContainerTelcel ? "#757575" : "#9b9b9b"}
                        > 
                            { "Total de comisiones*: "} 
                            <TextAmount 
                                color={!isClaroPartner && isContainerTelcel && comisionTotal == 0 && servicesIdTAE.includes(this.props.serviceId) ? "#008000" : amountColor}
                                fontSize={!isClaroPartner && isContainerTelcel ? "12px" : undefined}
                                weight={!isClaroPartner && isContainerTelcel ? "normal" : undefined}
                                fontFamily= "AMX-Bold"
                                aria-label={parseFloat(comisionTotal) + " pesos"}>
                                    <span aria-hidden="true">{"$" + comisionTotal}</span>                                    
                            </TextAmount> 
                            <span 
                                style={{
                                    width:"30px", 
                                    display:"inline-block",
                                    margin:"0px 0px 0px 2px",
                                    textAlign:"center"
                                    
                                }}
                                onClick = {this.handleOnclickDetailComision}
                            >
                                <img 
                                    src={(this.state.showDetailComision)? showLess: showMore} 
                                    height={imgHeight}
                                    width={imgWidth}
                                    style={{verticalAlign:imgVerticalAlign}}
                                />
                            </span>
                            
                        </ClaroParagraph>
                        
                        {
                            this.state.showDetailComision  && (comisionService != "0.00" || comisionCard != "0.00") ? (
                                <ClaroParagraph  
                                    margin={marginDetailCommissions}  
                                    normal={true} 
                                    align={alignComisions} 
                                    fontSize={!isClaroPartner && isContainerTelcel ? "12px" : "11px"}
                                    fontFamily={!isClaroPartner && isContainerTelcel ? "AMX-Regular" : "roboto"}
                                    fontColor={!isClaroPartner && isContainerTelcel ? "#757575" : "#9b9b9b"}>
                                    { "Comisión por el pago de servicio: " } 
                                    <TextAmount 
                                        color={amountColor}
                                        weight={!isClaroPartner && isContainerTelcel ? "normal" : "bold"}
                                        aria-label={parseFloat(comisionService) + " pesos"}>
                                            <span aria-hidden="true">{"$" + comisionService}</span>                                            
                                    </TextAmount>
                                </ClaroParagraph>) : ""
                        }
                        { 
                            this.state.showDetailComision && (comisionCard != "0.00" || comisionService != "0.00") ? (
                                <ClaroParagraph  
                                margin={marginDetailCommissions}  
                                normal={true} align={alignComisions} 
                                fontSize={!isClaroPartner && isContainerTelcel ? "12px" : "11px"}
                                fontFamily={!isClaroPartner && isContainerTelcel ? "AMX-Regular" : "roboto"}
                                fontColor={!isClaroPartner && isContainerTelcel ? "#757575" : "#9b9b9b"}>
                                { " Comisión por método de pago: " } 
                                <TextAmount 
                                    color={amountColor}
                                    weight={!isClaroPartner && isContainerTelcel ? "normal" : "bold"}
                                    aria-label={parseFloat(comisionCard) + " pesos"}>
                                        <span aria-hidden="true">{"$" + comisionCard.toFixed(2)}</span>                                        
                                </TextAmount>
                            </ClaroParagraph>) : ""
                        }
                        { 
                            this.state.showDetailComision && comisionCard == "0.00" && comisionService == "0.00"?(
                                <ClaroParagraph  
                                    margin={marginDetailCommissions} 
                                    normal={true} align={alignComisions} 
                                    fontSize={!isClaroPartner && isContainerTelcel ? "12px" : "11px"}
                                    fontFamily={!isClaroPartner && isContainerTelcel ? "AMX-Regular" : "roboto"}
                                    fontColor={!isClaroPartner && isContainerTelcel ? "#757575" : "#9b9b9b"}>
                                    { "Esta transacción no genera comisión." } 
                                </ClaroParagraph>) : ""
                        }
                        { 
                            this.state.showDetailComision ?(
                                <ClaroParagraph  
                                    margin={!isClaroPartner && isContainerTelcel ? "4px 0px 0px 0px" : "0em 0em 1em 0em"} 
                                    normal={true} align={alignComisions} 
                                    fontSize={!isClaroPartner && isContainerTelcel ? "12px" : "11px"}
                                    fontFamily={!isClaroPartner && isContainerTelcel ? "AMX-Regular" : "roboto"}
                                    fontColor={!isClaroPartner && isContainerTelcel ? "#757575" : "#9b9b9b"}>
                                    { "*IVA incluido" }
                                </ClaroParagraph>) : ""
                        }
                        
                    </>
                }
                <ClaroParagraph 
                    margin={!isClaroPartner && isContainerTelcel ? "10px 0px 15px 0px" : "0em 3em 0em 3em"} 
                    normal={true} 
                    align={"center"} 
                    fontSize={!isClaroPartner && isContainerTelcel ? "12px" : "11px"}
                    fontFamily={!isClaroPartner && isContainerTelcel ? "AMX-Regular" : "roboto"}
                    fontColor={!isClaroPartner && isContainerTelcel ? "#757575" : "#9b9b9b"}
                    style={{ lineHeight: paymentTypeLineHeight }}>
                    {this.props.paymentType}
                </ClaroParagraph>
            </Container>
        )
    }
}

export default CommisionModule;